<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import { mapActions, mapGetters } from "vuex";
export default {
    page: {
        title: "Wingband",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Layout,
        PageHeader,
    },
    computed: {
        ...mapGetters("auth", ["profile"]),
        ...mapGetters("seasonColors", { seasonColors: "colors" }),
    },
    data() {
        return {
            title: "Wingband",
            shouldShowDraftMessage: false,
            wingband_obj: {
                stag_number: [],
                breeders: [],
                farm_name: [],
                farm_address: [],
                province: [],
                chapter: [],
                contact_number: [],
                wingband_number: [],
                feather_color: [],
                leg_color: [],
                comb_shape: [],
                nose_markings: [],
                feet_markings: [],
            },
            wingband_data: [
                {
                    stag_number: '',
                    breeders: '',
                    farm_name: '',
                    farm_address: '',
                    province: '',
                    chapter: '',
                    contact_number: '',
                    wingband_number: '',
                    feather_color: '',
                    leg_color: '',
                    comb_shape: '',
                    nose_markings: '',
                    feet_markings: '',
                    disableStag: false,
                    disableWingBand: false,
                }
            ],
            wingband_date: '',
            selectedSeason: null,
            addRowModal: false,
            addAnotherRow: null,
            filter: {
                date: '',
            },
            row: {
                stag_number: 0,
            },
            data: {
                list: [],
                links: [],
                current_page: 1,
                per_page: 1,
                last_page: 1,
            },
            submitted: false,
        };
    },
    created() {
        const total = this.$route.query.wingband_data;
        const draft = localStorage.getItem('wingband_draft');
        
        if (total) {
            localStorage.removeItem('wingband_draft');
            this.wingband_data = Array.from({ length: parseInt(total, 10) }, () => ({ 
                stag_number: '', 
                breeders: '',
                farm_name: '',
                farm_address: '',
                province: '',
                chapter: '',
                contact_number: '',
                wingband_number: '',
                feather_color: '',
                leg_color: '',
                comb_shape: '',
                nose_markings: '',
                feet_markings: '',
                disableStag: false, 
                disableWingBand: false 
            }));
        } else if (draft) {
            const parsed = JSON.parse(draft);
            if (parsed.wingband_data && parsed.wingband_data.length > 0) {
                this.wingband_data = parsed.wingband_data;
                this.wingband_date = parsed.wingband_date || '';
                this.shouldShowDraftMessage = true;
            }
        } else {
            this.wingband_data = [];
        }
    },
    methods: {
        ...mapActions("wingband", {
            getDataList: "getDataList",
            createWingband: "createWingband",
        }),
        async initList(p) {
            var pl = {
                page: p,
                limit: 100,
                sort: "created_at",
                order: "desc",
            };
            this.loading = true;
            const data = await this.getDataList(pl);
            this.loading = false;
            this.data.list = data.data;
            this.data.links = data.links;
            this.data.current_page = data.current_page;
            this.data.per_page = data.per_page;
            this.data.last_page = data.last_page;
        },
        checkForDuplicates(event, index) {
            let value = event.target.value;

            // Remove non-numeric characters
            value = value.replace(/\D/g, '');

            // Update input + model
            event.target.value = value;
            this.wingband_data[index].wingband_number = value;

            // Your duplicate logic here...
        },
        allowNumbersOnly(event) {
            const char = String.fromCharCode(event.which);
            if (!/[0-9]/.test(char)) {
                event.preventDefault();
            }
        },
        isFieldInvalid(row, field) {
            try {
                // if (this.submitted && (!row[field] || row[field].trim() === "")) {
                if (this.submitted && (!row[field] || String(row[field]).trim() === "")) {
                    return true;
                }
                return false;
            } catch (e) {
                console.log('An Error Occured', row[field])
            }
        },
        defaultRows() {
            return {
                stag_number: '',
                breeders: '',
                farm_name: '',
                farm_address: '',
                province: '',
                chapter: '',
                contact_number: '',
                wingband_number: '',
                feather_color: '',
                leg_color: '',
                comb_shape: '',
                nose_markings: '',
                feet_markings: '',
                disableStag: false,
                disableWingBand: false,
                hasDuplicate: false,
            };
        },
        addRow(){
            Swal.fire({
                title: "Warning",
                text: `Are you sure you want to add more row?`,
                icon: "warning",
                showCancelButton: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    for (let i = 0; i < this.addAnotherRow; i++) {
                        this.wingband_data.push(this.defaultRows());
                    }
                    this.addRowModal = false;
                }
            })
        },
        async submitData() {
            this.submitted = true;

            if (this.wingband_data.length === 0) {
                Swal.fire({
                    title: "Warning",
                    html: `No rows available. Please go <strong>back</strong> and start a new wingbanding.`,
                    icon: "warning",
                });
                return;
            }
            let isValid = true;
            for (let row of this.wingband_data) {
                const requiredFields = [
                    'stag_number', 'breeders', 'farm_name', 'farm_address', 'province',
                    'chapter', 'contact_number', 'wingband_number', 'feather_color',
                    'leg_color', 'comb_shape', 'nose_markings', 'feet_markings'
                ];
                row['wingband_date'] = this.wingband_date
                for (let field of requiredFields) {
                    console.log(`Checking field: ${field}, Value:`, row[field]);
                    // if (!row[field] || row[field].trim() === "") {
                    if (!row[field] ||  String(row[field]).trim() === "") {
                        isValid = false;
                        break;
                    }
                }
                if (!isValid) break;
            }

            if (!isValid) {
                Swal.fire({
                    title: "Warning",
                    text: "Please fill all the required fields.",
                    icon: "warning",
                });
                return;
            }

            try {
                const confirmed = await Swal.fire({
                    title: "Are you sure?",
                    html: `You want to SAVE and EXIT?`,
                    icon: "warning",
                    confirmButtonColor: "#556ee6",
                    showCancelButton: true,
                    padding: "2em",
                }).then((result) => result.isConfirmed);

                if (this.wingband_date && confirmed) {
                    if (!this.selectedSeason) {
                        Swal.fire({
                            title: "Warning",
                            text: "The selected date does not belong to any season. Please choose a valid date.",
                            icon: "warning",
                        });
                        return;
                    }

                    var pl = {
                        wingband_data: this.wingband_data,
                        wingband_date: this.wingband_date,
                        season: this.selectedSeason.label,
                    };

                    const res = await this.createWingband(pl);
                    console.log(res)
                    if (res.status == 201) {
                        Swal.fire({
                            title: "Saved",
                            text: `Wingband for ${this.wingband_date} saved successfully!`,
                            icon: "success",
                        });
                        this.clearDraft();
                        this.goBack();
                    } else {
                        Swal.fire({
                            title: "Failed",
                            text: res.message,
                            icon: "error",
                        });
                    }
                } else {
                    Swal.fire({
                        title: "Warning",
                        text: `You forgot to fill the date.`,
                        icon: "warning",
                    });
                }
            } catch (error) {
                console.error("Error creating admin:", error);
                Swal.fire({
                    icon: "error",
                    title: "Error!",
                    text: "An unexpected error occurred. Please try again.",
                });
            }
        },
        deleteRow(index) {
            Swal.fire({
                title: "Warning",
                text: `Are you sure you want to delete this row?`,
                icon: "warning",
                showCancelButton: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.wingband_data.splice(index, 1);
                }
            })
        },
        fillStagNumber(event,index) {
            if (event.target.value) {
                var stagNo = event.target.value;
                this.wingband_data.slice(index).forEach(row => {
                    row.stag_number = stagNo;
                    row.disableStag = true;
                    // stagNo++;
                });
                this.wingband_data[index].disableStag = true;
            }
        },
        fillBreeders(event, index) {
            if (event.target.value) {
                this.wingband_data.slice(index).forEach(row => {
                    row.breeders = event.target.value;
                    row.disableBreeders = true;
                });
                this.wingband_data[index].disableBreeders = true;
            }
        },
        fillFarmName(event, index) {
            if (event.target.value) {
                this.wingband_data.slice(index).forEach(row => {
                    row.farm_name = event.target.value;
                    row.disableFarmName = true;
                });
                this.wingband_data[index].disableFarmName = true;
            }
        },
        fillFarmAddress(event,index) {
            if (event.target.value) {
                this.wingband_data.slice(index).forEach(row => {
                    row.farm_address = event.target.value;
                    row.disableFarmAddress = true;
                });
                this.wingband_data[index].disableFarmAddress = true;
            }
        },
        fillProvince(event, index) {
            if (event.target.value) {
                this.wingband_data.slice(index).forEach(row => {
                    row.province = event.target.value;
                    row.disableProvince = true;
                });
                this.wingband_data[index].disableProvince = true;
            }
        },
        fillChapter(event, index) {
            const value = this.wingband_data[index].chapter;
            if (value) {
                this.wingband_data.slice(index + 1).forEach(row => {
                    row.chapter = value;
                });
            }
        },
        fillContactNumber(event,index) {
            if (event.target.value) {
                this.wingband_data.slice(index).forEach(row => {
                    row.contact_number = event.target.value;
                    row.disableContactNumber = true;
                });
                this.wingband_data[index].disableContactNumber = true;
            }
        },
        fillWingBandNumber(event,index) {
            if (event.target.value) {
                let wbNo = event.target.value;
                this.wingband_data.slice(index).forEach(row => {
                    row.wingband_number = String(wbNo);
                    wbNo++;
                    row.disableWingBand = true;
                    row.hasDuplicate = false;
                });
                this.wingband_data[index].disableWingBand = true;
            }
        },
        fillEnter(event,index, input) {
            if(event.target.value && input == 'stag_number'){
                this.wingband_data[index].stag_number = event.target.value;
                this.wingband_data[index].disableStag = true;
            }else if(event.target.value && input == 'breeders'){
                this.wingband_data[index].breeders = event.target.value;
                this.wingband_data[index].disableBreeders = true;
            }else if(event.target.value && input == 'farm_name'){
                this.wingband_data[index].farm_name = event.target.value;
                this.wingband_data[index].disableFarmName = true;
            }else if(event.target.value && input == 'farm_address'){
                this.wingband_data[index].farm_address = event.target.value;
                this.wingband_data[index].disableFarmAddress = true;
            }else if(event.target.value && input == 'province'){
                this.wingband_data[index].province = event.target.value;
                this.wingband_data[index].disableProvince = true;
            }else if(event.target.value && input == 'chapter'){
                this.wingband_data[index].chapter = event.target.value;
                this.wingband_data[index].disableChapter = true;            }else if(event.target.value && input == 'contact_number'){
                this.wingband_data[index].contact_number = event.target.value;
                this.wingband_data[index].disableContactNumber = true;
            }else if(event.target.value && input == 'wingband_number'){
                const currentValue = event.target.value;
                var hasDuplicate;
                var duplicateValue;
                this.wingband_data.forEach((row,i) => {
                    if (i !== index && row.wingband_number === currentValue) {
                        hasDuplicate = true;
                        duplicateValue = row.wingband_number;
                    }
                });
                if(hasDuplicate){
                    Swal.fire({
                        title: "Warning",
                        text: `Check Duplicate Wingband Number: ${duplicateValue}`,
                        icon: "warning",
                        showCancelButton: false,
                        showConfirmButton: true,
                    })
                }else{
                    this.wingband_data[index].wingband_number = event.target.value;
                    this.wingband_data[index].disableWingBand = true;
                }
            }
        },
        enableInput(index,input) {
            if(input == 'stag_number'){
                this.wingband_data[index].disableStag = false;
            }else if(input == 'breeders'){
                this.wingband_data[index].disableBreeders = false;
            }else if(input == 'farm_name'){
                this.wingband_data[index].disableFarmName = false;
            }else if(input == 'farm_address'){
                this.wingband_data[index].disableFarmAddress = false;
            }else if(input == 'province'){
                this.wingband_data[index].disableProvince = false;
            }else if(input == 'breeders'){
                this.wingband_data[index].disableBreeders = false;
            }else if(input == 'chapter'){
                this.wingband_data[index].disableChapter = false;
            }else if(input == 'contact_number'){
                this.wingband_data[index].disableContactNumber = false;
            }else if(input == 'wingband_number'){
                this.wingband_data[index].disableWingBand = false;
            }
        },
        enableAllInputs() {
            this.wingband_data.forEach(row => {
                row.disableStag = false;
                row.disableWingBand = false;
                row.disableBreeders = false;
                row.disableFarmName = false;
                row.disableFarmAddress = false;
                row.disableContactNumber = false;
                row.disableProvince = false;
                row.disableChapter = false;
            });
        },
        handleKeyDown(event) {
            if (event.shiftKey && event.key === 'Enter') {
                this.enableAllInputs();
            }
        },
        goBack() {
            this.$router.push({ path: "/dashboard" });
        },
        saveDraft() {
            localStorage.setItem('wingband_draft', JSON.stringify({
                wingband_data: this.wingband_data,
                wingband_date: this.wingband_date,
            }));
        },
        loadDraft() {
            if (this.shouldShowDraftMessage) {
                Swal.fire({
                    title: "Draft Restored",
                    text: "Your previous unsaved entries have been restored.",
                    icon: "info",
                    timer: 3000,
                    showConfirmButton: false,
                    timerProgressBar: true,
                });
                this.shouldShowDraftMessage = false;
            }
        },
        clearDraft() {
            localStorage.removeItem('wingband_draft');
        },
        fieldTabIndex(row, fieldKey) {
            var val = row[fieldKey];
            var hasValue = val !== null && val !== undefined && String(val).trim() !== '';
            // Filled fields are skipped (-1); empty fields keep natural tab order (null = no override)
            return hasValue ? -1 : null;
        },
        getSeasonFromDate(date) {
            if (!date) return null;
            const d = new Date(date);
            const month = d.getMonth() + 1;
            const day = d.getDate();
            const mm = String(month).padStart(2, '0');
            const dd = String(day).padStart(2, '0');
            const md = mm + '-' + dd;

            var sc = this.seasonColors || {};
            if (md >= '01-02' && md <= '01-30') return { label: 'EARLY BIRD', color: sc.early_bird || '#6F42C1' };
            if (md >= '03-01' && md <= '03-30') return { label: 'LOCAL', color: sc.local || '#28A745' };
            if (md >= '04-01' && md <= '04-30') return { label: 'NATIONAL', color: sc.national || '#FFC107' };
            if (md >= '06-01' && md <= '06-30') return { label: 'LATEBORN', color: sc.late_born || '#ADB5BD' };
            if (md >= '11-02' && md <= '11-20') return { label: 'GENESIS', color: sc.genesis || '#0DCAF0' };
            return null;
        },
    },
    watch: {
        wingband_data: {
            deep: true,
            handler() {
                this.saveDraft();
            }
        },
        wingband_date(val) {
            this.selectedSeason = this.getSeasonFromDate(val);
            this.saveDraft();
        },
        selectedSeason() {
            this.saveDraft();
        }
    },
    mounted() {
        this.loadDraft();
        this.initList(1);
        window.addEventListener('keydown', this.handleKeyDown);
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card p-0">
                    <div class="col-lg-12 disflex">
                        <div class="col-4">
                            <button class="btn btn-info m-3" @click="addRowModal = true">
                                <i class="bx bx-plus"></i>
                                ADD MORE ROWS
                            </button>
                        </div>
                        <div class="col-4 mt-2">
                            <div class="disflex custom-border p-1 align-items-center">
                                <label class="filter-label me-2">Date:</label>
                                <input type="date" class="form-control" v-model="wingband_date">
                                <label class="filter-label ms-3 me-2">Season:</label>
                                <span v-if="selectedSeason" class="badge fs-6 px-3 py-2 text-uppercase season-badge" :style="{ backgroundColor: selectedSeason.color, color: '#fff' }">
                                    {{ selectedSeason.label }}
                                </span>
                                <span v-else class="badge fs-6 px-3 py-2 text-uppercase season-badge badge-secondary">
                                    NO SEASON FOUND
                                </span>
                            </div>
                        </div>
                        <div class="col-4 mt-2">
                            <div class="d-flex justify-content-end align-items-start me-2">
                                <button class="btn btn-danger" @click="goBack()">Back</button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-0">
                        <div class="table--responsive--md mt-3 custom-overflow">
                            <div class="tbl-header">
                                <table class="mb-0 table-bordered table">
                                    <thead>
                                        <tr class="bg-light">
                                            <th class="w-30"></th>
                                            <th class="w-30">ID</th>
                                            <th>Stag Registry No.</th>
                                            <th>Name of Breeders</th>
                                            <th>Farm Name</th>
                                            <th>Farm Address</th>
                                            <th>Province</th>
                                            <th>Chapter</th>
                                            <th>Contact No.</th>
                                            <th>Wingband No.</th>
                                            <th>Feather Color</th>
                                            <th>Leg Color</th>
                                            <th>Comb Shape</th>
                                            <th>Nose Markings</th>
                                            <th>Feet Markings</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="row, index in this.wingband_data" :key="index">
                                            <td class="w-30">
                                                <button class="btn btn-light btn-sm p-0" @click="deleteRow(index)">
                                                    <i class="mdi mdi-trash-can fs-3 text-danger cursor-pointer"
                                                        ></i>
                                                </button>
                                            </td>
                                            <td class="w-30">
                                                {{ index + 1}}
                                            </td>
                                            <td >
                                                <div class="d-flex position-relative" >
                                                    <input 
                                                        class="form-control" 
                                                        type="text" 
                                                        :disabled="row.disableStag" 
                                                        :value="row.stag_number"
                                                        :tabindex="fieldTabIndex(row, 'stag_number')"
                                                        @keydown.ctrl.enter="fillStagNumber($event, index)"
                                                        @keydown.tab="fillEnter($event,index,'stag_number')"
                                                        @focusout="fillEnter($event,index,'stag_number')"
                                                        :class="{ 'is-invalid': isFieldInvalid(row, 'stag_number') }"
                                                    />
                                                    <i v-if="row.disableStag" class="bx bx-pencil edit-pencil" @click="enableInput(index,'stag_number')" ></i>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="d-flex position-relative">
                                                    <input name="breeders" list="breeders" id="breeder" class="form-control"
                                                        type="text" 
                                                        :disabled="row.disableBreeders" :value="row.breeders"
                                                        :tabindex="fieldTabIndex(row, 'breeders')"
                                                        @keydown.ctrl.enter="fillBreeders($event, index)"
                                                        @keydown.tab="fillEnter($event,index,'breeders')"
                                                        @focusout="fillEnter($event,index,'breeders')"
                                                        :class="{ 'is-invalid': isFieldInvalid(row, 'breeders') }">
                                                    <i v-if="row.disableBreeders" class="bx bx-pencil edit-pencil" @click="enableInput(index,'breeders')" ></i>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="d-flex position-relative">
                                                    <input name="farm-name" list="farm-name" id="breeder"
                                                        class="form-control" type="text"
                                                        :disabled="row.disableFarmName" :value="row.farm_name"
                                                        :tabindex="fieldTabIndex(row, 'farm_name')"
                                                        @keydown.ctrl.enter="fillFarmName($event, index)"
                                                        @keydown.tab="fillEnter($event,index,'farm_name')"
                                                        @focusout="fillEnter($event,index,'farm_name')"
                                                        :class="{ 'is-invalid': isFieldInvalid(row, 'farm_name') }">
                                                    <i v-if="row.disableFarmName" class="bx bx-pencil edit-pencil" @click="enableInput(index,'farm_name')" ></i>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="d-flex position-relative">
                                                    <input name="farm-address" list="farm-address" id="farm-address"
                                                        class="form-control" type="text" 
                                                        :disabled="row.disableFarmAddress" :value="row.farm_address"
                                                        :tabindex="fieldTabIndex(row, 'farm_address')"
                                                        @keydown.ctrl.enter="fillFarmAddress($event,index)"
                                                        @keydown.tab="fillEnter($event,index,'farm_address')"
                                                        @focusout="fillEnter($event,index,'farm_address')"
                                                        :class="{ 'is-invalid': isFieldInvalid(row, 'farm_address') }">
                                                    <i v-if="row.disableFarmAddress" class="bx bx-pencil edit-pencil" @click="enableInput(index,'farm_address')" ></i>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="d-flex position-relative">
                                                    <input name="province" list="province" id="breeder" class="form-control"
                                                        type="text" 
                                                        :disabled="row.disableProvince" :value="row.province"
                                                        :tabindex="fieldTabIndex(row, 'province')"
                                                        @keydown.ctrl.enter="fillProvince($event,index)"
                                                        @keydown.tab="fillEnter($event,index,'province')"
                                                        @focusout="fillEnter($event,index,'province')"
                                                        :class="{ 'is-invalid': isFieldInvalid(row, 'province') }">
                                                    <i v-if="row.disableProvince" class="bx bx-pencil edit-pencil" @click="enableInput(index,'province')" ></i>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="d-flex position-relative">
                                                    <select
                                                        class="form-control"
                                                        :disabled="row.disableChapter"
                                                        v-model="row.chapter"
                                                        :tabindex="fieldTabIndex(row, 'chapter')"
                                                        @change="fillChapter($event, index)"
                                                        :class="{ 'is-invalid': isFieldInvalid(row, 'chapter') }">
                                                        <option value="" disabled>-- Select --</option>
                                                        <option v-for="c in profile.chapters" :key="c.id" :value="c.chapter">
                                                            {{ c.chapter }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="d-flex position-relative">
                                                    <input class="form-control" type="text"
                                                        :disabled="row.disableContactNumber" :value="row.contact_number"
                                                        :tabindex="fieldTabIndex(row, 'contact_number')"
                                                        @keydown.ctrl.enter="fillContactNumber($event,index)"
                                                        @keydown.tab="fillEnter($event,index,'contact_number')"
                                                        @focusout="fillEnter($event,index,'contact_number')"
                                                        :class="{ 'is-invalid': isFieldInvalid(row, 'contact_number') }">
                                                    <i v-if="row.disableContactNumber" class="bx bx-pencil edit-pencil" @click="enableInput(index,'contact_number')" ></i>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="d-flex position-relative">
                                                    <input class="form-control" type="text" 
                                                        :disabled="row.disableWingBand"
                                                        :value="row.wingband_number"
                                                        :tabindex="fieldTabIndex(row, 'wingband_number')"
                                                        @input="checkForDuplicates"
                                                        @keypress="allowNumbersOnly"
                                                        @keydown.ctrl.enter="fillWingBandNumber($event,index)"
                                                        @keydown.tab="fillEnter($event,index,'wingband_number')"
                                                        @focusout="fillEnter($event,index,'wingband_number')"
                                                        :class="{ 'is-invalid':row.hasDuplicate }">
                                                    <i v-if="row.disableWingBand" class="bx bx-pencil edit-pencil" @click="enableInput(index,'wingband_number')" ></i>
                                                </div>
                                            </td>
                                            <td>
                                                <!-- <datalist id="feather-color">
                                                    <option v-for="(feather, index) in data.list" :key="index"
                                                        :value="feather.feather_color">
                                                        {{ feather.feather_color }}
                                                    </option>
                                                </datalist>
                                                <input class="form-control" type="text"
                                                    name="featherColor" list="feather-color" id="featherColor"
                                                    v-model="row.feather_color"
                                                    :class="{ 'is-invalid': isFieldInvalid(row, 'feather_color') }"> -->
                                                <input class="form-control" type="text"
                                                    name="featherColor" id="featherColor"
                                                    v-model="row.feather_color"
                                                    autocomplete="off"
                                                    :class="{ 'is-invalid': isFieldInvalid(row, 'feather_color') }">
                                            </td>
                                            <td>
                                                <!-- <datalist id="leg-color">
                                                    <option v-for="(leg, index) in data.list" :key="index"
                                                        :value="leg.leg_color">
                                                        {{ leg.leg_color }}
                                                    </option>
                                                </datalist>
                                                <input class="form-control" type="text"
                                                    name="legColor" list="leg-color" id="legColor"
                                                    v-model="row.leg_color"
                                                    :class="{ 'is-invalid': isFieldInvalid(row, 'leg_color') }"> -->
                                                <input class="form-control" type="text"
                                                    name="legColor" id="legColor"
                                                    v-model="row.leg_color"
                                                    autocomplete="off"
                                                    :class="{ 'is-invalid': isFieldInvalid(row, 'leg_color') }">
                                            </td>
                                            <td>
                                                <input class="form-control" type="text"
                                                    name="combShape" list="comb-shape" id="combShape"
                                                    v-model="row.comb_shape"
                                                    autocomplete="off"
                                                    :class="{ 'is-invalid': isFieldInvalid(row, 'comb_shape') }">
                                            </td>
                                            <td>
                                                <datalist id="nose-marking">
                                                    <option v-for="row, index in this.data.list" :key="index">{{
                                                        row.nose_markings }}</option>
                                                </datalist>
                                                <input class="form-control" type="text"
                                                    name="nose-marking" list="nose-marking" id="nose-marking"
                                                    v-model="row.nose_markings"
                                                    autocomplete="off"
                                                    :class="{ 'is-invalid': isFieldInvalid(row, 'nose_markings') }">
                                            </td>
                                            <td>
                                                <!-- <datalist id="feet-marking">
                                                    <option v-for="(feet, index) in data.list" :key="index"
                                                        :value="feet.feet_markings">
                                                        {{ feet.feet_markings }}
                                                    </option>
                                                </datalist>
                                                <input class="form-control" type="text"
                                                    name="feetMarking" list="feet-marking" id="feetMarking"
                                                    v-model="row.feet_markings"
                                                    :class="{ 'is-invalid': isFieldInvalid(row, 'feet_markings') }"> -->
                                                <input class="form-control" type="text"
                                                    name="feetMarking" id="feetMarking"
                                                    v-model="row.feet_markings"
                                                    autocomplete="off"
                                                    :class="{ 'is-invalid': isFieldInvalid(row, 'feet_markings') }">
                                            </td>
                                        </tr>
                                    </tbody>
                                </table> 
                            </div>
                            <!-- <div class="tbl-content">
                                <table class="mb-0 table-bordered table hover-table">

                                </table>
                            </div> -->
                        </div>
                    </div>
                </div>
                <button class="btn btn-success fs-1 w-100" @click="submitData()">SAVE & EXIT</button>
            </div>
            <!-- MODALS -->
            <b-modal v-model="addRowModal" id="modal-sm" size="sm" title="Add row" title-class="font-18" hide-footer>
                <label>Number of rows</label>
                <input  class="form-control mb-3 w-100" v-model="addAnotherRow"/>
                <div class="text-end">
                    <button class="btn btn-success text-end" @click="addRow()">Add</button>
                </div>
            </b-modal>
        </div>
    </Layout>
</template>

<style scoped>
.w-30 {
    width: 30px !important;
}

th,
td {
    width: 75px !important;
    text-align: start;
}

.table> :not(caption)>*>* {
    text-align: center;
    padding: .5rem .1rem .5rem .1rem !important;
}

th {
    text-transform: uppercase;
}

.badge-violet   { background-color: #6f42c1; color: #fff; font-weight: 700; letter-spacing: 0.5px; border-radius: 6px; }
.badge-green    { background-color: #34c38f; color: #fff; font-weight: 700; letter-spacing: 0.5px; border-radius: 6px; }
.badge-yellow   { background-color: #f1b44c; color: #fff; font-weight: 700; letter-spacing: 0.5px; border-radius: 6px; }
.badge-silver   { background-color: #adb5bd; color: #fff; font-weight: 700; letter-spacing: 0.5px; border-radius: 6px; }
.badge-skyblue  { background-color: #0dcaf0; color: #fff; font-weight: 700; letter-spacing: 0.5px; border-radius: 6px; }
.badge-secondary { background-color: #74788d; color: #fff; font-weight: 700; letter-spacing: 0.5px; border-radius: 6px; }

.season-badge {
    font-size: 0.85rem !important;
    padding: 0.45rem 1rem !important;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    white-space: nowrap;
}
</style>